export const LOG = {
  GRIDCOLUMNS_logs_logging_loggingList: 'GRIDCOLUMNS_logs_logging_loggingList',
  GRIDCOLUMNS_logs_liveTail_liveList: 'GRIDCOLUMNS_logs_liveTail_liveList',
  FILTERSEARCH_logs_liveTail_liveList: 'FILTERSEARCH_logs_liveTail_liveList',
  FILTER_logs_logging: 'FILTER_logs_logging',
  FILTERSEARCH_logs_loggingList: 'FILTERSEARCH_logs_loggingList',
  SEARCH_OPTION_logging_searchOption: 'SEARCH_OPTION_logging_searchOption',

  // Logging Trend
  FIELD_OPTION_logging_trend_searchOption: 'FIELD_OPTION_logging_trend_search_option',
  FIELD_VALUES_logging_trend_loggingList: 'FIELD_VALUES_logging_trend_loggingList',
  TARGET_TAGS_logging_trend_loggingList: 'TARGET_TAGS_logging_trend_loggingList',
  SEARCH_OPTION_logging_trend_searchOption: 'SEARCH_OPTION_logging_trend_searchOption',
  SPARSE_RATE_logging_trend_sparseRate: 'SPARSE_RATE_logging_trend_sparseRate',

  GRIDCOLUMNS_logging_trend_targetView: 'GRIDCOLUMNS_logging_trend_targetView',
  GRIDCOLUMNS_logging_trend_loggingList: 'GRIDCOLUMNS_logging_trend_loggingList',
  FILTERSEARCH_logging_trend_targetView: 'FILTERSEARCH_logging_trend_targetView',
  FILTERSEARCH_logging_trend_loggingList: 'FILTERSEARCH_logging_trend_loggingList',

  // log detail
  GRIDCOLUMNS_logDetail_logInformation_table: 'GRIDCOLUMNS_logs_logDetail_logInformation_table',
  FILTERSEARCH_logDetail_logInformation_table: 'FILTERSEARCH_logs_logDetail_logInformation_table',

  // Detailed Log Analysis - Similar Logs
  GRIDCOLUMNS_detailedLogAnalysis_similarLogs_list:
    'GRIDCOLUMNS_logs_detailedLogAnalysis_similarLogs_list',
  FILTERSEARCH_detailedLogAnalysis_similarLogs_list:
    'FILTERSEARCH_logs_detailedLogAnalysis_similarLogs_list',
  // Detailed Log Analysis - Template Analysis
  FILTERSEARCH_detailedLogAnalysis_templateAnalysis_loggingList:
    'FILTERSEARCH_logs_detailedLogAnalysis_templateAnalysis_loggingList',
  GRIDCOLUMNS_detailedLogAnalysis_templateAnalysis_loggingList:
    'GRIDCOLUMNS_logs_detailedLogAnalysis_templateAnalysis_loggingList',

  // Template Analysis Window
  GRIDCOLUMNS_templateAnalysis_window_history:
    'GRIDCOLUMNS_logs_detailedLogAnalysis_templateAnalysis_history',
  FILTERSEARCH_templateAnalysis_window_history:
    'FILTERSEARCH_logs_detailedLogAnalysis_templateAnalysis_history',

  // Template Analysis Window - chart setting
  CHART_SETTING_logs_templateAnalysis_chartSetting:
    'CHART_SETTING_logs_templateAnalysis_chartSetting',

  TOGGLE_log_logDetail_basicInfo_expanded: 'TOGGLE_log_logDetail_basicInfo_expanded',
  TOGGLE_log_keywordLogDetail_basicInfo_expanded: 'TOGGLE_log_keywordLogDetail_basicInfo_expanded',
  TOGGLE_log_logDetail_logMessage_expanded: 'TOGGLE_log_logDetail_logMessage_expanded',
  TOGGLE_log_keywordLogDetail_logMessage_expanded:
    'TOGGLE_log_keywordLogDetail_logMessage_expanded',
  TAB_logs_logDetail_selected: 'TAB_logs_logDetail_selected',
  TAB_logs_keywordLogDetail_selected: 'TAB_logs_keywordLogDetail_selected',
  TAB_logs_detailedLogAnalysisDetail_selected: 'TAB_logs_detailedLogAnalysisDetail_selected',
};
